export function sortByPage(dataArray) {
    return [...dataArray].sort((a, b) => {
        // 1️⃣ Tri primaire : numéro de page
        const pageA = a.page ?? Infinity;
        const pageB = b.page ?? Infinity;
        if (pageA !== pageB) return pageA - pageB;

        // 2️⃣ Tri secondaire : position verticale (bbox_top)
        const topA = a.bbox_top ?? 0;
        const topB = b.bbox_top ?? 0;
        if (topA !== topB) return topA - topB;

        // 3️⃣ Tri tertiaire (stabilité) : ordre de création
        const createdA = new Date(a.created_at || 0);
        const createdB = new Date(b.created_at || 0);
        return createdA - createdB;
    });
}
